import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {TranslateService} from '@ngx-translate/core';

import {AbstractCRUD, BannerNotificationsService, CRUDService, ExceptionService, UtilsService} from '../../../xform-compat';
import { CompanyAudit } from '../../../shared/models';

/**
 * Data service to get company audits
 */
@Injectable({
  providedIn: 'root'
})
export class AuditsService extends AbstractCRUD<CompanyAudit> implements CRUDService<CompanyAudit> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
    private bannerNotificationService: BannerNotificationsService,
    private translateService: TranslateService
  ) {
    super(exceptionService, http, utilsService);
  }

  /**
   * Endpoint used just for company audits
   * Uses specific and required query params for the company audits section only
   * If audit logs is required in other pleases, create a new data service
   * @returns {string}
   */
  getResourcePath(): string {
    return '/measures/eventlogs';
  }

  /**
   * Downloads the history report
   * Create a temporal link to fire a programmatic click
   */
   downloadHistoryFile(url, headers) {
    super.getHTTP().get(url, {headers: headers, responseType: 'text'})
      .subscribe(
        (value: any) => {
          const hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:attachment/csv,' + encodeURI(value);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'audit-reports.csv';
          document.body.appendChild(hiddenElement);
          hiddenElement.click();
          this.bannerNotificationService.success(this.translateService.instant('GENERICS.DOWNLOADING'));
        },
        () => this.bannerNotificationService.error(this.translateService.instant('GENERICS.DOWNLOAD_ERROR'))
      );
  }

}
